import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { EopAssistantComponent } from '../components/eop-assistant/eop-assistant.component';
import { IntroductionComponent } from '../components/introduction/introduction.component';
import { PrvNextButtonsComponent } from '../components/prv-next-buttons/prv-next-buttons.component';
import { Icons } from '../../shared/helpers/icons';
import { RouterLink } from '@angular/router';
import { EditPlanComponent } from "./basic-plan-page/edit-plan/edit-plan.component";
import { UserDataService } from '../../shared/services/userData.service';
import { PopupMessageComponent } from "../components/popup-message/popup-message.component";
import { ICustomEopSection, IEopSection } from '../../shared/models/eopSection';
import { AddCustomPageComponent } from './custom-page/add-custom-page/add-custom-page.component';
import { EopSectionService } from '../../shared/services/eopSection.service';
import { CustomEopService } from '../../shared/services/customEop.service';
import { SpinnerComponent } from '../components/spinner/spinner.component';
import { DeleteConfirmationComponent } from '../components/delete-confirmation/delete-confirmation.component';
import { EditCustomPageComponent } from './custom-page/edit-custom-page/edit-custom-page.component';
import { EopNavigationService } from '../../shared/services/eopNavigation.service';
import { IUserInfo } from '../../shared/models/contact';
declare var initFlowbite: any;

@Component({
  selector: 'app-prepare-your-eop',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    EopAssistantComponent,
    IntroductionComponent,
    PrvNextButtonsComponent,
    RouterLink,
    EditPlanComponent,
    PopupMessageComponent,
    AddCustomPageComponent,
    EditCustomPageComponent,
    SpinnerComponent,
    DeleteConfirmationComponent
],
  templateUrl: './prepare-your-eop.component.html',
  styleUrl: './prepare-your-eop.component.css'
})
export class PrepareYourEopComponent implements OnInit {

  icons = Icons;
  currentBuildingId: string | null = null;
  currentUser: IUserInfo | null = null;
  
  messageModal: string | null = null;
  popupMessage: string | null = null;
  selectedCustomPage: any = null;
  buildingEopSections: IEopSection[] = [];
  buildingCustomEopSections: ICustomEopSection[] = [];

  loading: boolean = false;
  showIntro: boolean = false;
  showEditPlan: boolean = false;
  showAddCustomPage: boolean = false;
  showEditCustomPage: boolean = false;
  showDeleteConfirmation: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private userDataService: UserDataService,
    private eopSectionService: EopSectionService,
    private customEopService: CustomEopService,
    public eopNavigationService: EopNavigationService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.currentUser = this.userDataService.getUserData();
    this.loadBuildingEopSections();
    this.loadBuildingCustomEopSections();
    if (isPlatformBrowser(this.platformId)) {
      initFlowbite();
    }
  }

  loadBuildingEopSections(): void {
    if (this.currentBuildingId) {
      this.loading = true;
      this.eopSectionService.getEopSectionsByBuildingId(this.currentBuildingId).subscribe({
        next: (response) => {
          this.buildingEopSections = response.data;
          console.table(this.buildingEopSections);
          this.loading = false;
          setTimeout(() => {
            if (isPlatformBrowser(this.platformId)) {
              initFlowbite();
            }
          }, 50);
        },
        error: (error) => {
          console.error('Error loading EOP sections:', error);
          this.loading = false;
        }
      });
    }
  }

  loadBuildingCustomEopSections(): void {
    if (this.currentBuildingId) {
      this.loading = true;
      this.customEopService.getCustomEopByBuildingId(this.currentBuildingId).subscribe({
        next: (response) => {
          this.loading = false;
          console.table(this.buildingCustomEopSections);
          this.buildingCustomEopSections = response.data ? response.data : [];
          if (this.buildingCustomEopSections.length > 0) {
            this.buildingCustomEopSections.sort((a: ICustomEopSection, b: ICustomEopSection) => (a.title ?? '').localeCompare(b.title ?? ''));
          }
          setTimeout(() => {
            if (isPlatformBrowser(this.platformId)) {
              initFlowbite();
            }
          }, 50);
        },
        error: (error) => {
          console.error('Error loading custom EOP sections:', error);
          this.loading = false;
        }
      });
    }
  }

  handleOpenModal(modalName: string, selectedItem?: any): void {
    if (modalName === 'intro') {
      this.showIntro = true;
    } else if (modalName === 'edit-plan') {
      this.showEditPlan = true;
    } else if (modalName === 'add-custom-page') {
      this.showAddCustomPage = true;
    } else if (modalName === 'edit-custom-page') {
      this.showEditCustomPage = true;
      this.selectedCustomPage = selectedItem
    } else if (modalName === 'delete-confirmation') {
      this.showDeleteConfirmation = true;
      this.selectedCustomPage = selectedItem;

    }
  }

  handleCloseModal(modalName: string): void {
    if (modalName === 'intro') {
      this.showIntro = false;
    } else if (modalName === 'edit-plan') {
      this.showEditPlan = false;
    } else if (modalName === 'add-custom-page') {
      this.showAddCustomPage = false;
    } else if (modalName === 'edit-custom-page') {
      this.showEditCustomPage = false;
      this.selectedCustomPage = null; // Reset selected custom page
    } else if (modalName === 'delete-confirmation') {
      this.showDeleteConfirmation = false;
      this.selectedCustomPage = null;

    }
  }

  handleSave(message: {type: string, message: string}, actionType: string): void {
    this.handleCloseModal(actionType);
    this.loadBuildingEopSections();
    this.loadBuildingCustomEopSections();
    if (this.currentBuildingId) {
      this.eopNavigationService.loadTotalPages(this.currentBuildingId);
    }

    if (message.type === 'success') {
      // this.loadAssessmentsCases();
      this.messageModal = 'success';
      this.popupMessage = message.message;
      
    } else if (message.type === 'unsuccess') {
      this.messageModal = 'unsuccess';
      this.popupMessage = message.message;
    } 
  }

  deleteCustomPage(page: ICustomEopSection): void {
    if (this.selectedCustomPage) {
      this.loading = true;
      this.customEopService.deleteCustomPage(this.selectedCustomPage.id).subscribe({
        next: (response) => {
          this.handleCloseModal('delete-confirmation');
          this.loading = false;
          if (response.has_error) {
            console.error('Error deleting custom page:', response.message);
            this.messageModal = 'unsuccess';
            this.popupMessage = response.message;
            if (this.currentBuildingId) {
              this.eopNavigationService.loadTotalPages(this.currentBuildingId);
            }
          } else {
            this.loadBuildingCustomEopSections();
            this.messageModal = 'success';
            this.popupMessage = 'This occurred after deleting a custom page.';
          }
        },
        error: (error) => {
          this.loading = false;
          console.error('Error:', error.message);
          this.messageModal = 'unsuccess';
          this.popupMessage = error.message;
        }
      });
    }
  }
  
  canSave(): boolean {
    if (!this.currentUser) return false;
    return this.currentUser.can_edit || this.currentUser.can_admin;
  }

  resetMessageModal(): void {
    this.messageModal = null;
    this.popupMessage = null;
  }
}
